(() => {
  const root = document.querySelector('[data-hematite-power-aura]');
  if (!root) return;

  const q = (selector, scope = root) => scope.querySelector(selector);
  const qa = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const productsSection = q('#HematitePowerProducts');

  qa('[data-hp-scroll-products]').forEach((button) => {
    button.addEventListener('click', () => productsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  });

  qa('[data-hp-product-card]').forEach((card) => {
    const select = q('[data-hp-variant-select]', card);
    const input = q('[data-hp-variant-input]', card);
    const price = q('[data-hp-price]', card);
    const button = q('[data-add-to-cart]', card);
    const label = q('[data-hp-add-text]', card);
    if (!select) return;

    const update = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (input) input.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
    };
    select.addEventListener('change', update);
    update();
  });

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.1 }) : null;
  qa('[data-hp-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

  document.querySelectorAll('[data-ha-review-toggle]').forEach((button) => {
    const targetId = button.getAttribute('data-target');
    const target = targetId ? document.getElementById(targetId) : null;
    const label = button.querySelector('[data-ha-review-toggle-text]');
    if (!target || button.dataset.hpBound) return;
    button.dataset.hpBound = 'true';
    button.addEventListener('click', () => {
      const willOpen = target.hidden;
      target.hidden = !willOpen;
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (label) label.textContent = willOpen ? 'Daha az yorum göster' : (button.dataset.collapsedLabel || 'Yorumları göster');
    });
  });

  const sticky = q('[data-hp-sticky]');
  const hero = q('.hp-hero');
  const footer = q('.ha-footer');
  const progress = q('[data-hp-progress]');
  const updateScrollUi = () => {
    if (sticky && hero) {
      const show = hero.getBoundingClientRect().bottom < 90 && (!footer || footer.getBoundingClientRect().top > window.innerHeight + 40);
      sticky.classList.toggle('is-visible', show);
    }
    if (progress) {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = `${max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0}%`;
    }
  };

  let queued = false;
  window.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      updateScrollUi();
      queued = false;
    });
  }, { passive: true });
  updateScrollUi();
})();
